<template>
  <!DOCTYPE html>
  <html>
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="generator" content="Aspose.Words for .NET 22.7.0" />
      <title></title>
    </head>
    <body>
      <div class="awdiv awpage" style="width: 595.3pt; height: 841.9pt">
        <div class="awdiv" style="left: 90pt; top: 72pt">
          <span
            class="awspan awtext001"
            style="
              font-size: 20pt;
              color: #333333;
              left: 140.39pt;
              top: 44.76pt;
              line-height: 22.34pt;
            "
            >Privacy policy</span
          >
          <div class="awdiv" style="left: 126pt; top: 76.2pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10.5pt;
                left: 0pt;
                top: 2.11pt;
                line-height: 11.73pt;
              "
              >Updated and effective on 20 May 2023</span
            >
          </div>
          <div class="awdiv" style="top: 91.8pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #003476;
                left: 0pt;
                top: 12.38pt;
                line-height: 11.17pt;
              "
              >introduction</span
            >
          </div>
          <div class="awdiv" style="top: 122.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho is a "Software as a Service" platform (" Massho "or the"
              Platform ") designed to </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >provide merchants (" You "or the" Merchant ") with one-stop site
              building, traffic, payment, </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >logistics and other e-commerce solutions.</span
            >
          </div>
          <div class="awdiv" style="top: 194.8pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >When you visit our website and use our platform, we may collect
              and use your personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information, including that of your employees and/or those
              operating business on your behalf. </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >When your end users visit or place an order on Massho Assisted
              websites, you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 349.06pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 359.06pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >trust us to </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >collect and use your end users' personal information on your
              behalf. We are fully aware of the </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >importance of personal information to you and your end users
              (collectively referred to as </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >"Personal information Subject") and are committed to maintaining
              the information security of </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >the platform.</span
            >
          </div>
          <div class="awdiv" style="top: 329.6pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >We</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 17.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >formulate</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 59.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 61.73pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 96.75pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 99.27pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Privacy</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 132.06pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 134.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Policy</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 161.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 163.78pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(hereinafter</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 214.92pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 217.44pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >referred</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 252.46pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 254.98pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 263.32pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 265.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >as</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 276.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 278.93pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >"this</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 298.04pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 300.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Privacy</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 333.35pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 335.87pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Policy")</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.25pt;
                left: 369.43pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 371.95pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >according </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to the applicable laws and regulations. Through this Privacy
              policy, we hope to explain to the </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >subject of personal information how Massho collects, uses,
              stores, shares, transfers and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >discloses personal information in the process of providing
              products and/or services, the </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >purpose, method, scope and information security protection
              measures, as well as how the </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >subject of personal information realizes the rights and methods
              to manage its personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >information. </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 55.02pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >Before using the Platform, please carefully read and thoroughly
              understand </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 111.58pt;
                line-height: 11.17pt;
              "
              >this Privacy Policy, and use relevant products and/or services of
              the Platform after </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >confirming</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 51.67pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 54.35pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 76.02pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 78.7pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >full</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 93.69pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 96.37pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >understanding</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 165.82pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 168.5pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 186.28pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 188.96pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >consent.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 230.07pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 232.76pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >If</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 238.86pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 241.54pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 259.32pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 262pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >do</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 274.22pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 276.9pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >not</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 292.45pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 295.13pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >agree</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 321.81pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 324.5pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 344.49pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 347.17pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >any</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 364.4pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 367.08pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >content</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 403.19pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 405.87pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >of </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >this</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 17.78pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 20.36pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >Policy,</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 52.59pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 55.17pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 72.95pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 75.53pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >shall</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 98.32pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 100.9pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >immediately</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 158.7pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 161.28pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >stop</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 182.39pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 184.97pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >using</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 211.63pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 214.21pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 229.21pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 231.79pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >Platform</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 272.35pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 274.93pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 292.71pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 295.29pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >any</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 312.52pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 315.1pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >Massho</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 352.33pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 354.91pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >services.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 397.72pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 400.3pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >For </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 158.38pt;
                line-height: 11.17pt;
              "
              >your reading and understanding, please refer to the definitions
              of key terms in the Appendix to </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 173.98pt;
                line-height: 11.17pt;
              "
              >this Privacy Policy.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 83.35pt;
                top: 173.98pt;
                line-height: 11.17pt;
              "
            >
              Here are our special tips for you to focus on:</span
            >
          </div>
          <div class="awdiv" style="top: 537.4pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >1.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 8.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 11.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho mainly provides services for you, our merchants, to
              facilitate their </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >e-commerce business. If you use any Massho service to support the
              Online Store, for </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >the purpose of providing Massho service to you, we are entrusted
              by you to collect the </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >personal</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 41.68pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 44.36pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 99.36pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 102.04pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 111.48pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 114.16pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 129.16pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 131.84pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >end</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 149.62pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 152.3pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >users</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 178.99pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 181.67pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >when</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 207.23pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 209.91pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >they</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 230.47pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 233.15pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >visit</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 253.16pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 255.84pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 270.84pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 273.53pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >Online</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 304.64pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 307.32pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >store</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 331.77pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 334.46pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 344.46pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 347.14pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >place</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 372.71pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 375.39pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >an</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                letter-spacing: -0.1pt;
                left: 387.06pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 389.74pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >order </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >in the Online store, and to process such personal information
              according to your </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >instructions. From a legal point of view, we are a personal
              information processor and </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >process your end users' personal information in accordance with
              our agreement with </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 111.58pt;
                line-height: 11.17pt;
              "
              >you and this Privacy Policy. As the personal information
              controller, you assume all </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >responsibilities to your end users. Since you have the final say
              in how your end users' </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >personal information is used, you should ensure that your end
              users are aware of how
            </span>
          </div>
        </div>
      </div>
      <div class="awdiv awpage" style="width: 595.3pt; height: 841.9pt">
        <div class="awdiv" style="left: 90pt; top: 72pt">
          <span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 2.38pt;
              line-height: 11.17pt;
            "
            >you (and we are entrusted by you) collect and process their
            personal information. You </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >should</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 32.77pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 35.37pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >at</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 44.26pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 46.86pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >least</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 69.65pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 72.25pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >publish</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 107.8pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 110.39pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >your</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 132.06pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 134.66pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >Privacy</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 170.25pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 172.84pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >Agreement</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 225.08pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 227.67pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >in</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 236.56pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 239.16pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >your</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 260.83pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 263.42pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >online</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 292.87pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 295.46pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >store</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 319.92pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 322.51pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >to</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 331.95pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 334.55pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >inform</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 365.65pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 368.25pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >end</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.18pt;
              left: 386.03pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 388.62pt;
              top: 17.98pt;
              line-height: 11.17pt;
            "
            >users </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 33.58pt;
              line-height: 11.17pt;
            "
            >of what personal information you collect, how you use it, and with
            whom you share it. </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 49.18pt;
              line-height: 11.17pt;
            "
            >You are solely responsible for answering your end users' questions
            and requests </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 64.78pt;
              line-height: 11.17pt;
            "
            >regarding how you handle their personal information. If the end
            user has any questions </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >about</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 27.22pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 29.93pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >how</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 49.92pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 52.63pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >the</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 67.63pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 70.35pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >merchant</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 115.36pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 118.07pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >or</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 128.07pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 130.78pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >online</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 160.23pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 162.94pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >store</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 187.39pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 190.1pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >uses</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 212.89pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 215.6pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >and</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 233.38pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 236.09pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >handles</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 273.88pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 276.59pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >their</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 298.26pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 300.97pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >information,</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 358.75pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 361.46pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >please</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              letter-spacing: -0.07pt;
              left: 392.59pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
          >
          </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 395.3pt;
              top: 80.38pt;
              line-height: 11.17pt;
            "
            >also </span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              color: #333333;
              left: 0pt;
              top: 95.98pt;
              line-height: 11.17pt;
            "
            >review the privacy agreement of such merchant or online
            store.</span
          >
          <div class="awdiv" style="top: 129.8pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >2.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 8.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 10.88pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >For</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 25.88pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 28.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >all</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 38.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 40.96pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 54.86pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 57.4pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >key</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 72.96pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 75.5pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >contents,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 116.08pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 118.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >we</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 131.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 133.95pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >make</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 158.4pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 160.94pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 174.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 177.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >fonts</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 199.06pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 201.6pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >"</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 205.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >bold</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 226.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >".</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 232.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 235.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >For</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 250.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 252.66pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >sensitive</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 295.46pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 298pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >personal</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 339.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 342.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 397.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.24pt;
                left: 399.99pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 402.53pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >we </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >make the fonts "</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 71.92pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >bold italics</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 124.15pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >" to give a special reminder, hope you pay attention when
              reading. </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >Before you provide any </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 105.62pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >sensitive personal information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 250.65pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
              to us, you should have carefully </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >considered and hereby confirm that such provision is appropriate,
              and you hereby agree that </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >your </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 22.23pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >sensitive personal information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 167.27pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
              may be processed in accordance with the purpose and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >manner described in this Policy.</span
            >
          </div>
          <div class="awdiv" style="top: 244pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >3.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 8.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 11.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho only provides services for users over 18 years old
              (including). For minors </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >under the age of 18, we do not collect or provide any products
              and/or services of the </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >Platform. Before using our products and/or services, please
              confirm that you have met </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >the age requirements and have carefully read and understood the
              detailed information </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >in this policy.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 63.9pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
              We do not knowingly collect personal information from people under
              the age of </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >18. If you find that we have inadvertently collected minors'
              personal information, please inform </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >us immediately and we will try to delete the relevant data as
              soon as possible.</span
            >
          </div>
          <div class="awdiv" style="top: 378.8pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >4.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 8.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
              We provide you with the means to realize your personal information
              rights, including but not </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >limited to access or correct, delete your personal information,
              cancel your account, withdraw </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >consent and timely response, so as to ensure that you realize the
              control of your personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >information.</span
            >
          </div>
          <div class="awdiv" style="top: 466.8pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >This policy will help you understand the following:</span
            >
          </div>
          <div class="awdiv" style="top: 487.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 13.5pt;
                color: #334155;
                left: 0pt;
                top: 0.48pt;
                line-height: 15.08pt;
              "
              >I.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 7.5pt;
                top: 3.65pt;
                line-height: 11.17pt;
              "
              >How do we collect and use Personal information</span
            >
          </div>
          <div class="awdiv" style="top: 508pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 14pt;
                color: #333333;
                left: 0pt;
                top: 8.01pt;
                line-height: 15.64pt;
              "
              >a.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 14pt;
                color: #333333;
                left: 15.6pt;
                top: 8.01pt;
                line-height: 15.64pt;
              "
              >The information we collect</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 539.2pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Personal</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 60.47pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 63.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 112.88pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 115.82pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 131.94pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 134.89pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 167.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 170.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 178.97pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 181.91pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >us</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 192.47pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 195.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >about</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 220.44pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 223.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 239.5pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 242.44pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 259.13pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 262.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 281.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 284.46pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >employees</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 332.82pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 335.77pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.16pt;
                left: 344.66pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 347.6pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >authorized </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >persons,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 59.35pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 63.22pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >such</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 84.34pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 88.21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >as</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 98.77pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 102.64pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >name,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 130.43pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 134.3pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >email</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 158.19pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 162.06pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >address,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 200.41pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 204.28pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >telephone</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 248.21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 252.08pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >number,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 288.76pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 292.63pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >service</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 324.3pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 328.17pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >area,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.09pt;
                left: 350.96pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 354.83pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >business </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >address,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 59.35pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 61.93pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >login</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 83.06pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 85.63pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >password.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 131.21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 133.79pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >In</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 142.13pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 144.7pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >some</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 169.16pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 171.73pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >cases,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 200.63pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 203.21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >we</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 215.99pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 218.57pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >may</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 237.46pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 240.04pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >also</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 258.38pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 260.96pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >collect</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 289.3pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 291.88pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 311.33pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 313.91pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >address,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.2pt;
                left: 352.26pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 354.84pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >business </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >registration certificate information and tax number.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 601.6pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >The</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 38.23pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 41.51pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >payment</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 79.86pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 83.14pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 92.03pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 95.3pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >billing</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 120.87pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 124.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 173.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 176.89pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 193.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 196.29pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 229.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 232.36pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 240.7pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 243.98pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >us,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 257.32pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 260.59pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 300.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 303.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >credit</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 330.57pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 333.85pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 342.74pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 346.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >debit</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                letter-spacing: 0.5pt;
                left: 369.9pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 373.18pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >card </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >numbers</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 63.23pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
              or </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 77.68pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >bank account numbers</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 187.15pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >, and payment history</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 632.8pt">
            <span
              class="awspan awtext003"
              style="font-size: 10pt; left: 0pt; top: 3.43pt; line-height: 10pt"
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Content</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 56.02pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 60.19pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 109.66pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 113.83pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >uploaded</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 154.98pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 159.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 168.04pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 172.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >published</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 215.02pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 219.19pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >by</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 229.76pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 233.92pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 250.05pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 254.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >on</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 265.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 269.51pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 283.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 287.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Platform,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 327.59pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 331.76pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.39pt;
                left: 371.23pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 375.4pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >text, </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >pictures,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 58.79pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 62.89pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >audio</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 87.36pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 91.46pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >recordings,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 140.93pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 145.03pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >video</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 168.94pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 173.04pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >recordings</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 219.72pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 223.82pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 240.51pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 244.61pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 258.51pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 262.61pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >date,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 284.85pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 288.95pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >time</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 307.84pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 311.94pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 328.63pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 332.73pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >place</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 356.63pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 360.73pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.32pt;
                left: 369.07pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 373.17pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >such </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >information.</span
            >
          </div>
          <div class="awdiv" style="left: 42pt; top: 679.6pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >When</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 26.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 31.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 47.19pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 52.13pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 68.26pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 73.2pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 87.1pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 92.05pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >above</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 119.29pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 124.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >features,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 163.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 168.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >we</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 180.87pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 185.82pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >will</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 199.71pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 204.65pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >ask</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 220.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 225.16pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 241.28pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 246.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >for</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 257.89pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 262.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >authorization</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 320.1pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 325.04pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 333.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 338.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.17pt;
                left: 354.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 359.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the
            </span>
          </div>
        </div>
      </div>
      <div class="awdiv awpage" style="width: 595.3pt; height: 841.9pt">
        <div class="awdiv" style="left: 90pt; top: 72pt">
          <div class="awdiv" style="left: 21pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >camera,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 57.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 60.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >photo</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 85.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 88.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >album,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 118.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 121.43pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >microphone</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 173.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 176.77pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 193.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 196.54pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >location</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 231.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 234.1pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >permissions</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 287.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 290.54pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >in</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 298.32pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 301.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 320.86pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 323.95pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >terminal</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.31pt;
                left: 359.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 362.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >device. </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >You</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 38.79pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 42.03pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >may</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 60.92pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 64.16pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >choose</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 96.41pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 99.64pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >whether</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 135.22pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 138.46pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 146.8pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 150.03pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 182.83pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 186.07pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >such</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 207.19pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 210.43pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >authorization</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 267.69pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 270.93pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 279.27pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 282.5pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >us.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 295.84pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 299.08pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >If</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 304.64pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 307.87pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 324pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 327.23pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >refuse,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 357.8pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 361.04pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.46pt;
                left: 377.16pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 380.4pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >will </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >not</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 34.9pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 39.22pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >be</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 50.34pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 54.66pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >able</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 73.56pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 77.88pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 86.22pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 90.54pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 106.66pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 110.98pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 124.88pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 129.2pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >relevant</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 164.77pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 169.09pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >functions,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 211.89pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 216.21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >but</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 230.11pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 234.43pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 250.55pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 254.87pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >can</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 270.99pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 275.31pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >still</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 289.75pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 294.07pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 310.19pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 314.51pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >other</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 337.3pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 341.62pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >functions</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.54pt;
                left: 381.64pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 385.96pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >of </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >Massho.</span
            >
          </div>
          <div class="awdiv" style="left: 42pt; top: 62.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Please</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 30.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 33.53pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >ensure</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 64.11pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 67.06pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >that</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 83.74pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 86.69pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 100.59pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 103.55pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >relevant</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 139.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 142.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >content</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 174.88pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 177.83pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >does</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 199.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 202.47pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >not</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 216.37pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 219.32pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >contain</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 251.57pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 254.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 273.97pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 276.93pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 285.82pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 288.77pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 302.67pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 305.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >user's</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.18pt;
                left: 331.99pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 334.94pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 52.25pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 57.11pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >If</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 62.67pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 67.53pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 83.66pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 88.52pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >include</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 120.21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 125.08pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >relevant</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 160.65pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 165.52pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >personal</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 203.88pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 208.74pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 260.99pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 265.85pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >please</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 295.32pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 300.18pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >ensure</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 330.76pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 335.63pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >that</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.09pt;
                left: 352.31pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 357.17pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >have obtained the express consent of the personal information
              subject.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 109.2pt">
            <span
              class="awspan awtext003"
              style="font-size: 10pt; left: 0pt; top: 3.43pt; line-height: 10pt"
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 42.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 48.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 90.89pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 96.85pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 116.31pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 122.27pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >employees</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 170.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 176.59pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 193.28pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 199.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >authorized</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 245.94pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 251.91pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >persons)</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 290.81pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 296.78pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >device</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 325.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 331.65pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.19pt;
                left: 381.11pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 387.08pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >is </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >collected</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 60.47pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 63.02pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >by</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 73.58pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 76.12pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >us</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 86.69pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 89.23pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >through</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 123.15pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 125.7pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >"cookies"</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 166.7pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 169.25pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 178.14pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 180.69pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >similar</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 209.58pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 212.12pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >technology,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 263.27pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 265.82pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 305.29pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 307.84pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >personal</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.23pt;
                left: 346.2pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 348.74pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >commonly </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >used</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 42.69pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 48.77pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >device</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 77.68pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 83.77pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >information,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 136.01pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 142.1pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 181.57pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 187.66pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >IP</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 197.11pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 203.19pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >address,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 241.55pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 247.63pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >device</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 276.54pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 282.63pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >model,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 312.64pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 318.73pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >device</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.31pt;
                left: 347.64pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 353.72pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >identifier, </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >operating</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 62.7pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 67.74pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >system,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 102.19pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 107.22pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >resolution,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 153.36pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 158.4pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 175.08pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 180.12pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >telecom</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 215.14pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 220.18pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >carrier;</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 251.29pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 256.33pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >And</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 274.12pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 279.16pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >log</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 292.5pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 297.54pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >information,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.26pt;
                left: 349.79pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 354.82pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >including </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >detailed</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 56.03pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 60.58pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 110.05pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 114.61pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >about</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 139.63pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 144.18pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 163.64pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 168.19pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 184.31pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 188.87pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 197.21pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 201.76pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 215.66pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 220.22pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >platform</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 256.34pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 260.89pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 277.58pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 282.13pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >saved</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 308.82pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 313.37pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >as</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 323.93pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 328.49pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >a</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 334.05pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 338.6pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >network</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.78pt;
                left: 373.62pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 378.17pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >log, </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 60.47pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 68.58pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >network</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 103.59pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 111.69pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >diagnosis,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 156.72pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 164.83pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >logjam</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 194.28pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 202.39pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >information,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 254.63pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 262.74pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >click</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 282.18pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 290.28pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >events,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 322.52pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 330.63pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >click</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 5.33pt;
                left: 350.07pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 358.17pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >records, </span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >browsing history</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 101.56pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
            >
              and urls of potential risks.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 218.4pt">
            <span
              class="awspan awtext003"
              style="font-size: 10pt; left: 0pt; top: 3.43pt; line-height: 10pt"
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >When</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 47.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 50.05pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 66.18pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 69.11pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >apply</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 93.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 95.95pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 112.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 115.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 131.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 134.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 169.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 172.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >POS,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 196.46pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 199.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 232.19pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 235.12pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >us</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 245.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 248.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 266.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 269.32pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >more</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 292.11pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 295.04pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 344.51pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 347.44pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >about</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.15pt;
                left: 372.46pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 375.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you, </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >including your address, store name, email, PIN, and commuting
              time.</span
            >
          </div>
          <div class="awdiv" style="top: 249.6pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 14pt;
                color: #333333;
                left: 0pt;
                top: 8.01pt;
                line-height: 15.64pt;
              "
              >b.</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 14pt;
                color: #333333;
                left: 15.6pt;
                top: 8.01pt;
                line-height: 15.64pt;
              "
              >Purpose and usage scenarios of information collection</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 280.8pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Verify</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 46.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 50.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 69.7pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 73.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >identity</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 105.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 108.75pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 117.64pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 121.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >that</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 138.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 141.69pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 150.03pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 153.72pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 173.17pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 176.85pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >employees</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 225.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 228.9pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 245.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 249.27pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >authorized</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 295.96pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 299.65pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >persons,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 338pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 341.69pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.91pt;
                left: 374.48pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 378.17pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 38.78pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 42.84pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 92.31pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 96.37pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >related</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 126.94pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 131pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 139.34pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 143.4pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 162.85pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 166.91pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 183.03pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 187.09pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 195.43pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 199.48pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 213.38pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 217.44pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >Platform</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 254.67pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 258.73pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >(such</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 283.18pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 287.24pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >as</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 297.8pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 301.86pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >providing</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 342.44pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 346.5pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >verification </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >codes,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 50.46pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 54.52pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >contacting</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 100.1pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 104.16pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 120.28pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 124.34pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >about</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 149.36pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 153.42pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 172.87pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 176.92pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >use</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 193.05pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 197.1pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 205.99pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 210.05pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >problems</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 251.18pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 255.23pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 273.02pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 277.07pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 290.97pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 295.03pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >Platform,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 335.04pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 339.09pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >sending</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.28pt;
                left: 374.12pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 378.18pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >bills or invoices), and publicize new features or services of the
              Platform to you.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 343.2pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >We</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 36pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 40.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >will</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 54.11pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 58.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >charge</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 88.91pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 93.13pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 109.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 113.47pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 127.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 131.6pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >corresponding</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 194.97pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 199.19pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >service</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 230.87pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 235.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >fee</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 248.99pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 253.21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >according</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 296.57pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 300.79pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 309.13pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 313.36pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.44pt;
                left: 332.81pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 337.03pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >authorization </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 37.69pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 47.69pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >help</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 66.59pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 69.27pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 85.39pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 88.06pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 96.4pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 99.08pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >query</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 124.09pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 126.77pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 140.67pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 143.34pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >transaction</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 192.26pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 194.93pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >records</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 228.28pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 230.95pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >that</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 247.63pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 250.3pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >have</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 271.99pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 274.66pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >taken</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 299.13pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 301.8pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >place</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 325.71pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 328.38pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >in</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 336.16pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 338.84pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.1pt;
                left: 352.74pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 355.41pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >platform.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 374.4pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >We</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 36pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 40.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 73.64pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 78.49pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 94.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 99.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 117.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 122.08pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 135.98pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 140.83pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >services</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 177.5pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 182.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 190.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 195.53pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >this</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 211.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 215.93pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >platform,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 254.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 259.68pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >including</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 299.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 304pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >store</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 326.23pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 331.07pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >operation</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.07pt;
                left: 372.77pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 377.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >customer management.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 405.6pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >We</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 36pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 41.91pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 74.71pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 80.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 96.74pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 102.65pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 120.43pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 126.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 143.03pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 148.93pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >improve</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 184.5pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 190.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 204.31pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 210.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >functions</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 250.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 256.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 272.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 278.75pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >services</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 315.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 321.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 329.67pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 335.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 3.13pt;
                left: 349.48pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 355.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >platform; </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >Summarize</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 71.57pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 76.66pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 93.34pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 98.43pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >analyze</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 132.9pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 137.99pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 187.45pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 192.54pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 200.88pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 205.97pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 238.77pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 243.86pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 259.98pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 265.07pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >with</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 282.85pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 287.94pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >more</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 310.73pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 315.82pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >personalized</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 2.31pt;
                left: 372.52pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 377.61pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >customized</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 71.58pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 74.61pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >services;</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 114.07pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 117.11pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >recommend</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 169.9pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 172.94pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >our</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 187.39pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 190.43pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >new</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 208.78pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 211.82pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >features</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 247.95pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 250.99pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 267.67pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 270.71pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >services</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 307.38pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 310.42pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 318.76pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 321.8pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you;</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 340.7pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 343.74pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >To</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 355.41pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 358.45pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >find</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.26pt;
                left: 374.57pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 377.61pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >troubleshoot problems.</span
            >
          </div>
          <div class="awdiv" style="left: 21pt; top: 468pt">
            <span
              class="awspan awtext003"
              style="
                font-size: 10pt;
                color: #333333;
                left: 0pt;
                top: 3.43pt;
                line-height: 10pt;
              "
              ></span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >It</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 26.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 30.64pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >is</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 37.86pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 41.95pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >used</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 63.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 67.72pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 76.06pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 80.14pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >establish</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 119.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 123.7pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 140.38pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 144.47pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >manage</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 180.61pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 184.69pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 204.14pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 208.23pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Massho</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 243.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 247.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >POS</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 268.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 272.53pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >accounts,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 315.33pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 319.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >provide</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 352.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 356.3pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 1.31pt;
                left: 372.43pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 376.51pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >with </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 21pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >Massho POS services, and ensure the security of your account
              information.</span
            >
          </div>
          <div class="awdiv" style="top: 514.8pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 13.5pt;
                color: #334155;
                left: 0pt;
                top: 0.48pt;
                line-height: 15.08pt;
              "
              >(I)</span
            ><span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #333333;
                left: 12.74pt;
                top: 3.65pt;
                line-height: 11.17pt;
              "
              >Authorization and consent of the end user</span
            >
          </div>
          <div class="awdiv" style="top: 530.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >For the purpose of using the Platform and Massho Services, you
              understand and agree to </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >entrust us with the collection, storage and processing of
              personal information from your end </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >users and promise that you have obtained the sufficient and
              necessary authorization, consent </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >and permission of end users to allow us to directly collect and
              use their personal information </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 64.78pt;
                line-height: 11.17pt;
              "
              >for the purposes required to perform the services. If you entrust
              us with the personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 80.38pt;
                line-height: 11.17pt;
              "
              >information of any third party (including your end users), you
              shall ensure that you have </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 95.98pt;
                line-height: 11.17pt;
              "
              >obtained the sufficient and necessary authorization, consent and
              permission of the third party </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 111.58pt;
                line-height: 11.17pt;
              "
              >to allow us to process and use such personal information for the
              purposes indicated by you </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 127.18pt;
                line-height: 11.17pt;
              "
              >before providing it. We have the right to reject your request to
              entrust processing of third party </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 142.78pt;
                line-height: 11.17pt;
              "
              >personal information due to the requirements and restrictions of
              laws and regulations.</span
            >
          </div>
        </div>
      </div>
      <div class="awdiv awpage" style="width: 595.3pt; height: 841.9pt">
        <div class="awdiv" style="left: 90pt; top: 72pt">
          <span
            class="awspan awtext002"
            style="
              font-size: 13.5pt;
              color: #334155;
              left: 0pt;
              top: 0.48pt;
              line-height: 15.08pt;
            "
            >(</span
          ><a name="_GoBack" style="left: 4.5pt; top: 0pt"></a
          ><span
            class="awspan awtext002"
            style="
              font-size: 13.5pt;
              color: #334155;
              left: 4.5pt;
              top: 0.48pt;
              line-height: 15.08pt;
            "
            >II)</span
          ><span
            class="awspan awtext001"
            style="
              font-size: 10pt;
              left: 16.49pt;
              top: 3.65pt;
              line-height: 11.17pt;
            "
            >The exception to authorized consent</span
          >
          <div class="awdiv" style="top: 15.6pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >According to applicable laws and regulations, the personal
              information collected and used in </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the following circumstances does not require the consent of the
              personal information subject:</span
            >
          </div>
          <div class="awdiv" style="top: 51.8pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(1) Those related to the performance of obligations prescribed by
              laws and regulations;</span
            >
          </div>
          <div class="awdiv" style="top: 72.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(2) Those directly related to national security and national
              defense security;</span
            >
          </div>
          <div class="awdiv" style="top: 93pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(3) those directly related to public security, public health or
              major public interests;</span
            >
          </div>
          <div class="awdiv" style="top: 113.6pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(4)</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 12.22pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 14.96pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >those</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 39.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 42.16pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >directly</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 73.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 76.58pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >related</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 107.15pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 109.89pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 118.23pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 120.97pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >criminal</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 155.42pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 158.16pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >investigation,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 216.53pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 219.27pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >prosecution,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 273.74pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 276.48pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >trial</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 292.6pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 295.34pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 312.02pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 314.76pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >execution</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 357.57pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 360.31pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: -0.04pt;
                left: 368.65pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 371.39pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >judgment;</span
            >
          </div>
          <div class="awdiv" style="top: 134.2pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(5) For the purpose of safeguarding the life, property and other
              major legitimate rights and </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >interests of the subject of personal information or other
              individuals, but it is difficult to obtain </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >the authorization and consent of the person;</span
            >
          </div>
          <div class="awdiv" style="top: 186pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(6) The personal information involved is disclosed to the public
              by the subject of personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information;</span
            >
          </div>
          <div class="awdiv" style="top: 222.2pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(7) Necessary to sign and perform the contract as required by the
              subject of personal </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >information;</span
            >
          </div>
          <div class="awdiv" style="top: 258.4pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(8) Collecting personal information from legally publicly
              disclosed information;</span
            >
          </div>
          <div class="awdiv" style="top: 279pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(9) Maintenance necessary to provide safe and stable operation of
              our platform, such as </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >finding and handling faults of products and/or services of our
              Platform;</span
            >
          </div>
          <div class="awdiv" style="top: 315.2pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >(10) Other circumstances stipulated by laws and
              regulations.</span
            >
          </div>
          <div class="awdiv" style="top: 351.4pt">
            <span
              class="awspan awtext001"
              style="
                font-size: 10pt;
                color: #040c13;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >Privacy policy update.</span
            >
          </div>
          <div class="awdiv" style="top: 367pt">
            <span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >As</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 11.67pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 14.45pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >we</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 27.24pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 30.02pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 46.71pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 49.49pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >our</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 63.94pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 66.73pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >customers</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 112.85pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 115.63pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >grow</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 137.31pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 140.09pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 156.78pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 159.56pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >evolve,</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 191.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 194.03pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >we</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 206.81pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 209.6pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >may</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 228.49pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 231.27pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >need</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 253.52pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 256.3pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 264.64pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 267.43pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >update</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 298.01pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 300.8pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >our</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 315.25pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 318.04pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >privacy</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 349.71pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 352.49pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >policy.</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 380.84pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 383.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >We</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.01pt;
                left: 398.62pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 401.41pt;
                top: 2.38pt;
                line-height: 11.17pt;
              "
              >will </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >notify</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 23.9pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 27.02pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 43.14pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 46.26pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >before</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 74.61pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 77.73pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >any</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 93.85pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 96.97pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >major</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 121.97pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 125.09pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >change</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 157.9pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 161.02pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >takes</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 184.92pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 188.03pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >effect</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 212.49pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 215.61pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >by</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 226.17pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 229.29pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >email</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 253.18pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 256.3pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >(sent</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 278.53pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 281.65pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >to</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 289.99pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 293.11pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >the</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 307.01pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 310.12pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >email</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 334.02pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 337.14pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >address</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0.34pt;
                left: 372.71pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 375.83pt;
                top: 17.98pt;
                line-height: 11.17pt;
              "
              >specified </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >in</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 7.78pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 10.57pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >your</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 30.02pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 32.8pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >account)</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 71.15pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 73.94pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >or</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 82.83pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 85.61pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >by</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 96.17pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 98.95pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >Posting</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 132.31pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 135.09pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >a</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 140.65pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 143.43pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >notice</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 170.12pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 172.9pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >on</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 184.02pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 186.81pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >this</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 202.37pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 205.15pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >website</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 239.06pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 241.84pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >and</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 258.52pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 261.31pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >inform</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 289.09pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 291.87pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 307.99pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 310.78pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >of</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 319.12pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 321.9pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >any</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 338.02pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 340.8pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >choices</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 374.71pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 377.49pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >you</span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                letter-spacing: 0pt;
                left: 393.61pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
            >
            </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 396.4pt;
                top: 33.58pt;
                line-height: 11.17pt;
              "
              >may </span
            ><span
              class="awspan awtext002"
              style="
                font-size: 10pt;
                left: 0pt;
                top: 49.18pt;
                line-height: 11.17pt;
              "
              >make regarding these changes.</span
            >
          </div>
        </div>
      </div>
    </body>
  </html>
</template>

<script setup></script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Arial';
  font-style: normal;
  font-weight: bold;
  src: local('☺'),
    url('data:application/x-font-woff;base64,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')
      format('woff');
}
@font-face {
  font-family: 'Arial';
  font-style: normal;
  font-weight: normal;
  src: local('☺'),
    url('data:application/x-font-woff;base64,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')
      format('woff');
}
@font-face {
  font-family: 'Webdings';
  font-style: normal;
  font-weight: normal;
  src: local('☺'),
    url('data:application/x-font-woff;base64,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')
      format('woff');
}
.awdiv {
  position: absolute;
}
.awspan {
  position: absolute;
  white-space: pre;
  color: #000000;
  font-size: 12pt;
}
.awimg {
  position: absolute;
}
.awsvg {
  position: absolute;
}
.awpage {
  position: relative;
  border: solid 1pt black;
  margin: 10pt auto 10pt auto;
  overflow: hidden;
}
@media print {
  body {
    margin: 0pt;
    padding: 0pt;
  }
  .awpage {
    page-break-after: always;
    margin: 0pt;
    padding: 0pt;
  }
}
.awtext001 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: bold;
}
.awtext002 {
  font-family: 'Arial';
  font-style: normal;
  font-weight: normal;
}
.awtext003 {
  font-family: 'Webdings';
  font-style: normal;
  font-weight: normal;
}
</style>
